'use strict';

module.exports = function () {
    // Product main image carousel changes slides
    $('body').on('beforeChange', '.primary-image-carousel', function () {
        var $videoSlide = $('.slick-current .video-embed');
        if ($videoSlide.length > 0 && $videoSlide[0].contentWindow) {
            $videoSlide[0].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        }
    });
};
